import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { toHttpParams } from "@/_utility/querystring";
import { GlobalSearchGroup } from "@/_models/global-search.model";

@Injectable({ providedIn: "root" })
export class GlobalSearchService {
    constructor(private readonly httpClient: HttpClient) {}

    search(query: string): Observable<GlobalSearchGroup[]> {
        return this.httpClient.get<GlobalSearchGroup[]>("api/search", {
            params: toHttpParams({ query }),
        });
    }
}
